import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Admin.css';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function Admin() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadStats();
    const interval = setInterval(loadStats, 5000);
    return () => clearInterval(interval);
  }, []);

  const loadStats = async () => {
    try {
      const res = await fetch(`${API_URL}/api/stats`);
      const data = await res.json();
      setStats(data);
    } catch (err) {
      console.error('Stats error:', err);
    }
  };

  const triggerIngestion = async () => {
    setLoading(true);
    setMessage('Starting ingestion...');
    
    try {
      const res = await fetch(`${API_URL}/api/ingest`, { method: 'POST' });
      const data = await res.json();
      setMessage('Ingestion started! New articles will appear in 1-2 minutes.');
      setTimeout(loadStats, 5000);
    } catch (err) {
      setMessage('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const generateAllArticles = async () => {
    setLoading(true);
    setMessage('Generating articles for all events...');
    
    try {
      const res = await fetch(`${API_URL}/api/generate-all`, { method: 'POST' });
      const data = await res.json();
      setMessage(data.message);
      setTimeout(loadStats, 10000);
    } catch (err) {
      setMessage('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="admin-panel">
        <div className="admin-header">
          <h1>Platform Admin</h1>
          <Link to="/" className="btn btn-outline">View Feed</Link>
        </div>

        {stats && (
          <div className="stats-grid">
            <div className="stat-card card">
              <div className="stat-icon">📰</div>
              <div className="stat-content">
                <div className="stat-value">{stats.total_articles}</div>
                <div className="stat-label">Total Articles</div>
              </div>
            </div>
            
            <div className="stat-card card">
              <div className="stat-icon">🔥</div>
              <div className="stat-content">
                <div className="stat-value">{stats.total_events}</div>
                <div className="stat-label">Events Detected</div>
              </div>
            </div>
            
            <div className="stat-card card">
              <div className="stat-icon">📊</div>
              <div className="stat-content">
                <div className="stat-value">{stats.total_posts}</div>
                <div className="stat-label">Posts Ingested</div>
              </div>
            </div>
            
            <div className="stat-card card">
              <div className="stat-icon">⏰</div>
              <div className="stat-content">
                <div className="stat-value">{stats.recent_articles_24h}</div>
                <div className="stat-label">Recent (24h)</div>
              </div>
            </div>
          </div>
        )}

        <div className="actions-section card">
          <h3>Actions</h3>
          
          <div className="action-buttons">
            <button 
              className="btn btn-primary"
              onClick={triggerIngestion}
              disabled={loading}
            >
              Trigger Reddit Ingestion
            </button>
            
            <button 
              className="btn btn-primary"
              onClick={generateAllArticles}
              disabled={loading}
            >
              Generate Articles for Events
            </button>
          </div>

          {message && (
            <div className="message-box">
              {message}
            </div>
          )}
        </div>

        <div className="info-section card">
          <h3>System Info</h3>
          <ul>
            <li><strong>Multi-Agent System:</strong> GPT-4o (Editor, Researcher, Journalist, Fact-Checker)</li>
            <li><strong>Clustering:</strong> TF-IDF + BIRCH algorithm</li>
            <li><strong>Sources:</strong> r/news, r/worldnews, r/breakingnews (RSS feeds)</li>
            <li><strong>Confidence Scoring:</strong> Platform trust + Engagement + Verification</li>
            <li><strong>Real-time Updates:</strong> Server-Sent Events (SSE)</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Admin;
